



































import { Component, Prop, Emit, Vue } from 'vue-property-decorator'
import CoreIcon from './CoreIcon.vue'

@Component({
    components: { CoreIcon },
})
export default class CorePasswordInput extends Vue {
    @Prop({ default: '' }) public placeholder!: string
    @Prop({ default: '' }) public label!: string
    @Prop({ default: '' }) public validationMessage!: string
    @Prop({ default: false }) public disabled!: boolean
    @Prop() public invalid!: string
    @Prop() public value!: string

    public active = false
    public visible = false

    public focus() {
        this.active = true
    }

    public get type() {
        return this.visible ? 'text' : 'password'
    }

    public toggleViewable() {
        this.visible = !this.visible
    }

    public get withPrefix() {
        return !!this.$slots.prefix
    }

    public get inputInnerClasses() {
        return {
            active: this.active,
            disabled: this.disabled,
            invalid: this.invalid,
        }
    }

    @Emit('input')
    public input(e: any): string {
        this.change()
        return e.target.value
    }

    @Emit('change')
    public change(): string {
        return this.value
    }

    @Emit('blur')
    public blur() {
        this.active = false
    }
}
